/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const PaintingIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / painting</title>
            <g fillRule="nonzero" fill="#FCA61B">
                <path d="M35 6v34H11V6h24zm1-1H10v36h26V5z"/>
                <path d="M11 9.5C9.076 9.5 7.5 7.924 7.5 6S9.076 2.5 11 2.5s3.5 1.576 3.5 3.5h1c0-2.476-2.024-4.5-4.5-4.5S6.5 3.524 6.5 6s2.024 4.5 4.5 4.5v-1zM35 10.5c2.476 0 4.5-2.024 4.5-4.5S37.476 1.5 35 1.5 30.5 3.524 30.5 6h1c0-1.924 1.576-3.5 3.5-3.5s3.5 1.576 3.5 3.5-1.576 3.5-3.5 3.5v1zM11 35.5c-2.476 0-4.5 2.024-4.5 4.5s2.024 4.5 4.5 4.5 4.5-2.024 4.5-4.5h-1c0 1.924-1.576 3.5-3.5 3.5S7.5 41.924 7.5 40s1.576-3.5 3.5-3.5v-1zM35 36.5c1.924 0 3.5 1.576 3.5 3.5s-1.576 3.5-3.5 3.5-3.5-1.576-3.5-3.5h-1c0 2.476 2.024 4.5 4.5 4.5s4.5-2.024 4.5-4.5-2.024-4.5-4.5-4.5v1z"/>
                <path d="M38 7.5v30h1v-30M7 7v30h1V7M32 2H14v1h18M32 43H14v1h18M19.5 18.207L29.293 28H36v-1h-6.293L19.5 16.793l-9.354 9.353.708.708M29 18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/>
            </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Painting.tsx